const CalendarIcon = ({ active }) => {
  const color = active ? "#0149AD" : "#545454";
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 0.75V2M2.75 0.75V2"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 10.125L5.24999 7.84201C5.24999 7.72216 5.16453 7.625 5.05911 7.625H4.625M7.51853 10.125L8.36511 7.84323C8.40469 7.73654 8.32052 7.625 8.20043 7.625H7.125"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M0.5625 7.15203C0.5625 4.42871 0.5625 3.06705 1.34507 2.22103C2.12765 1.375 3.38718 1.375 5.90625 1.375H7.09375C9.61282 1.375 10.8724 1.375 11.6549 2.22103C12.4375 3.06705 12.4375 4.42871 12.4375 7.15203V7.47297C12.4375 10.1963 12.4375 11.5579 11.6549 12.404C10.8724 13.25 9.61282 13.25 7.09375 13.25H5.90625C3.38718 13.25 2.12765 13.25 1.34507 12.404C0.5625 11.5579 0.5625 10.1963 0.5625 7.47297V7.15203Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.75 4.5H10.25"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
